import React, { FC } from "react";

import { GeneralInfoHeader } from "./Components/GeneralInfoHeader";
import { GeneralInfoBody } from "./Components/GeneralInfoBody";
import { InfoWithBanner } from "../../InfoWithBanner";
import { InsuranceDoctorDto } from "@apiModels/Insurance/InsuranceDoctorDto.csharp";
import { InsuranceTreaterClinic } from "../../../../../Pages/InsuranceTreater/InsuranceTreaterClinic.csharp";

interface TreaterGeneralInfoProps {
  doctor: InsuranceDoctorDto;
  clinics: InsuranceTreaterClinic[];
  insurancePracticalInfo: string;
}

export const TreaterGeneralInfo: FC<TreaterGeneralInfoProps> = (props) => {
  const { doctor, clinics, insurancePracticalInfo } = props;
  return (
    <InfoWithBanner
      header={<GeneralInfoHeader {...doctor} />}
      body={
        <GeneralInfoBody
          insurancePracticalInfo={insurancePracticalInfo}
          clinics={clinics}
          {...doctor}
        />
      }
    />
  );
};
